import MDubbingResponderSetting from './index.vue';

MDubbingResponderSetting.install = app => {
  app.component(MDubbingResponderSetting.name, MDubbingResponderSetting);
};

export default MDubbingResponderSetting;
